
$(document).ready(function() {
  var elem = document.querySelector("#modalFiltros");
  if (elem == null) {
    return;
  }


  window.vueAppModalFiltros = new Vue({
    el: elem,
    data: {
      horaInicio: null,
      horaFin: null,

      disabledTimes: function _default(date) {
        return false
      },
      disabledTimesFin: function _default(date) {
        return false
      },
      timePickerOptions: {
        start: '05:00',
        step:'01:00' ,
        end: '22:00'
      },

      timePickerFinOptions: {
        start: '00:00',
        step:'01:00' ,
        end: '23:00'
      },

      precioMin: 0,
      precioMax: 0,

      personasMin: 0,
      personasMax: 0,
    },

    mounted() {
      window.vueAppModalFiltros = this
      this.precioMin = parseFloat($("#precio-minimo").val())
      this.precioMax = parseFloat($("#precio-maximo").val())

      this.personasMin = parseFloat($("#personas-minimo").val())
      this.personasMax = parseFloat($("#personas-maximo").val())

      $(".slider-range.precios").slider({
        range: true,
        min: window.vueAppModalFiltros.precioMin,
        max: window.vueAppModalFiltros.precioMax,
        values: [window.vueAppModalFiltros.precioMin, window.vueAppModalFiltros.precioMax],
        slide: function( event, ui ) {
          $( "#precio-minimo" ).val(ui.values[0]);
          $( "#precio-maximo" ).val(ui.values[1]);
        }
      });

      $("#precio-minimo").keyup((e) => {
        $(".slider-range.precios").slider({
          values: [parseFloat($("#precio-minimo").val()),  parseFloat($("#precio-maximo").val())],
        });
      })
      $("#precio-maximo").keyup((e) => {
        $(".slider-range.precios").slider({
          values: [parseFloat($("#precio-minimo").val()),  parseFloat($("#precio-maximo").val())],
        });
      })

      try{
        if(window.location.search.length > 0){
          const searchParams = new URLSearchParams(window.location.search);
          const decodedParams = Array
            .from(searchParams.keys())
            .reduce((acc, key) => ({ ...acc, [key]: searchParams.get(key) }), {});
          if(decodedParams.personas_max != null){
            $("#personas-maximo").val(decodedParams.personas_max)
          }
          if(decodedParams.personas_min != null){
            $("#personas-minimo").val(decodedParams.personas_min)
          }
          if(decodedParams.precio_max != null){
            $("#precio-maximo").val(decodedParams.precio_max)
          }
          if(decodedParams.precio_min != null){
            $("#precio-minimo").val(decodedParams.precio_min)
          }

          $(".slider-range.precios").slider({
            values: [parseFloat($("#precio-minimo").val()),  parseFloat($("#precio-maximo").val())],
          });

          if(decodedParams.servicios != null){
            let servicios = decodedParams.servicios.split(",")
            for (let index in servicios){
              let check = document.querySelector("#servicio"+servicios[index])
              if(check != null){
                check.checked = true
              }
            }
          }
          if(decodedParams.hora_inicio != null && decodedParams.hora_inicio.length > 0){
            this.horaInicio = dayjs(decodedParams.hora_inicio, "hh:mm a").toDate();
          }
          if(decodedParams.hora_fin != null && decodedParams.hora_fin.length > 0){
            this.horaFin = dayjs(decodedParams.hora_fin, "hh:mm a").toDate();
          }
          // this.filtros = {...this.filtros,...decodedParams}
        }
      }
      catch (error){
        ReportErrorLog(error)
        console.error(error)
      }
    },
    methods: {
      limpiarFiltros(){

        document.querySelectorAll(".servicio-filtro-check").forEach(elem => {
          elem.checked = false
        })

        $("#precio-minimo").val(this.precioMin)
        $("#precio-maximo").val(this.precioMax)

        $("#personas-minimo").val(this.personasMin)
        $("#personas-maximo").val(this.personasMax)

        $(".slider-range.precios").slider({
          values: [this.precioMin, this.precioMax],
        });

        this.horaInicio = null;
        this.horaFin = null;

        this.$forceUpdate()

        window.callbackFiltros(document.querySelector("#modalFiltros form"))
        $("#modalFiltros").modal("hide")
      },
      filtrarSubmit(e){
        window.callbackFiltros(e.target);
        $("#modalFiltros").modal("hide")
      }
    }
  });
});
